import React from 'react';
import BlogLink from './BlogLink';
import { heights, widths, fonts } from './../../../styles/theme.json';

const BlogLandingGrid = (props) => {
  const Articles = props.blogLandingData.map((item, i) =>
    <BlogLink data={item} key={item.image.id + '-id-' + i}/>
  );
  return (
    <section id={'blog-landing'}>
      <ul id={'blog-repeater'}>
        {Articles}
      </ul>
      <style jsx>{`
        #blog-landing {
          margin-top: ${heights.header};
          max-width: calc(${widths.global_max_width} + (${widths.double_pad} * 2));
          text-align: center;
          //padding: 0 ${widths.double_pad};
          display: flex;
          flex-direction: column;
          min-height: calc(100vh - 12rem);
        }
        #blog-repeater {
          list-style: none;
        }
      `}</style>
    </section>
  );
};

export default BlogLandingGrid;



// WEBPACK FOOTER //
// ./src/pages/blog/blog_landing/BlogLandingGrid.js